import { getEstadoCuentaDevolucionDowload } from "../services/documentosService";
import { getDevolucionesEstatusAll, getDevolucionesEstatusAllLista, getDevolucionesPendientesAll, getDevolucionesPendientesAllVersion, putDeclinarSolitudRembolsoAgente, putValidateDevolucion } from "../services/refoundService";

const dataInicial = {
    listDevolucionesPendientes: [],
    listaDevolucionesCombo: [],
    pagina: 0,
    registros: 10,
    busqueda: "0",
    total: 0,
    exito: 0,
    version: 1,
    estatus: 1,
};

const GET_DEVOLUCIONES_PENDIENTES_ALL = "GET_DEVOLUCIONES_PENDIENTES_ALL";
const GET_DEVOLUCIONES_PENDIENTES_PAGINA = "GET_DEVOLUCIONES_PENDIENTES_PAGINA";
const GET_DEVOLUCIONES_PENDIENTES_REGISTROS = "GET_DEVOLUCIONES_PENDIENTES_REGISTROS";
const GET_DEVOLUCIONES_PENDIENTES_BUSQUEDA = "GET_DEVOLUCIONES_PENDIENTES_BUSQUEDA";
const CLEAR_DEVOLUCIONES_PENDIENTES = "CLEAR_DEVOLUCIONES_PENDIENTES";
const GET_DEVOLUCIONES_ESTADO_CUENTA_DOWLOAD = "GET_DEVOLUCIONES_ESTADO_CUENTA_DOWLOAD"
const PUT_DEVOLUCIONES_PENDIENTES_APROVAR = "PUT_DEVOLUCIONES_PENDIENTES_APROVAR"
const PUT_DEVOLUCIONES_PENDIENTES_DECLINAR = "PUT_DEVOLUCIONES_PENDIENTES_DECLINAR"
const GET_DEVOLUCIONES_PENDIENTES_VERSION = "GET_DEVOLUCIONES_PENDIENTES_VERSION"
const GET_DEVOLICIONES_PENDIENTES_ESTATUS = "GET_DEVOLICIONES_PENDIENTES_ESTATUS"
const GET_DEVOLUCIONES_PENDIENTES_LISTADO = "GET_DEVOLUCIONES_PENDIENTES_LISTADO"

export default function devolucioenesPendientesReducer(state = dataInicial, action) {
    switch (action.type) {
        case GET_DEVOLUCIONES_PENDIENTES_LISTADO:
            return { ...state, listaDevolucionesCombo: action.payload.listaDevolucionesCombo }
        case GET_DEVOLICIONES_PENDIENTES_ESTATUS:
            return { ...state, listDevolucionesPendientes: action.payload.listDevolucionesPendientes, total: action.payload.total, estatus: action.payload.estatus }
        case GET_DEVOLUCIONES_PENDIENTES_VERSION:
            return { ...state, listDevolucionesPendientes: action.payload.listDevolucionesPendientes, total: action.payload.total, version: action.payload.version }
        case PUT_DEVOLUCIONES_PENDIENTES_DECLINAR:
            return { ...state, exito: action.payload.exito }
        case PUT_DEVOLUCIONES_PENDIENTES_APROVAR:
            return { ...state, exito: action.payload.exito }
        case GET_DEVOLUCIONES_ESTADO_CUENTA_DOWLOAD:
            return { ...state, exito: action.payload.exito }
        case GET_DEVOLUCIONES_PENDIENTES_ALL:
            return { ...state, listDevolucionesPendientes: action.payload.listDevolucionesPendientes, total: action.payload.total }
        case GET_DEVOLUCIONES_PENDIENTES_PAGINA:
            return { ...state, listDevolucionesPendientes: action.payload.listDevolucionesPendientes, pagina: action.payload.pagina, total: action.payload.total }
        case GET_DEVOLUCIONES_PENDIENTES_REGISTROS:
            return { ...state, listDevolucionesPendientes: action.payload.listDevolucionesPendientes, registros: action.payload.registros, total: action.payload.total }
        case GET_DEVOLUCIONES_PENDIENTES_BUSQUEDA:
            return { ...state, listDevolucionesPendientes: action.payload.listDevolucionesPendientes, busqueda: action.payload.busqueda, total: action.payload.total, pagina: action.payload.pagina, registros: action.payload.registros }
        case CLEAR_DEVOLUCIONES_PENDIENTES:
            return { ...state, listDevolucionesPendientes: action.payload.array, pagina: action.payload.pagina, registros: action.payload.registros, busqueda: action.payload.busqueda }
        default:
            return state;
    }
}
export const obtenerDevolucionesPendientesListadoAction = () => async (dispatch, getSate) => {
    const { estatus } = getSate().devolucionesPendientes
    return await getDevolucionesEstatusAllLista({ IdCatEstatusDevolucion: estatus }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_PENDIENTES_LISTADO,
            payload: {
                listaDevolucionesCombo: Response,
            },
        });
        return Response
    }).catch(Error => {
        return []
    })
}
//! No se usa en el proyecto
export const obtenerDevolucionesPendientesVersionAction = ({ version }) => async (dispatch, getSate) => {
    const { busqueda, registros, pagina, } = getSate().devolucionesPendientes
    return await getDevolucionesEstatusAll({ Pagina: pagina + 1, Referencia: busqueda, Registros: registros, IdCatVersionPaquete: version }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_PENDIENTES_VERSION,
            payload: {
                listDevolucionesPendientes: Response.Devoluciones,
                total: Response.Total,
                version: version,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerDevolucionesPendientesEstatusAction = ({ estatus }) => async (dispatch, getSate) => {
    return await getDevolucionesEstatusAll({ Pagina: dataInicial.pagina + 1, Referencia: dataInicial.busqueda, Registros: dataInicial.registros, IdCatEstatusDevolucion: estatus }).then(Response => {
        dispatch({
            type: GET_DEVOLICIONES_PENDIENTES_ESTATUS,
            payload: {
                listDevolucionesPendientes: Response.Devoluciones,
                total: Response.Total,
                estatus: estatus
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerDevolucionesPendientesAction = () => async (dispatch, getSate) => {
    const { busqueda, pagina, registros, estatus } = getSate().devolucionesPendientes
    return await getDevolucionesEstatusAll({ Pagina: pagina + 1, Referencia: busqueda, Registros: registros, IdCatEstatusDevolucion: estatus }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_PENDIENTES_ALL,
            payload: {
                listDevolucionesPendientes: Response.Devoluciones,
                total: Response.Total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}

export const obtenerDevolucionesPendientesPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { busqueda, registros, estatus } = getSate().devolucionesPendientes
    return await getDevolucionesEstatusAll({ Pagina: Pagina + 1, Referencia: busqueda, Registros: registros, IdCatEstatusDevolucion: estatus }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_PENDIENTES_PAGINA,
            payload: {
                listDevolucionesPendientes: Response.Devoluciones,
                pagina: Pagina,
                total: Response.Total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerDevolucionesPendientesRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { busqueda, pagina, estatus } = getSate().devolucionesPendientes
    return await getDevolucionesEstatusAll({ Referencia: busqueda, Pagina: pagina + 1, Registros, IdCatEstatusDevolucion: estatus }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_PENDIENTES_REGISTROS,
            payload: {
                listDevolucionesPendientes: Response.Devoluciones,
                total: Response.Total,
                registros: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerDevolucionesPendientesBusquedaAction = ({ Referencia }) => async (dispatch, getSate) => {
    const { estatus } = getSate().devolucionesPendientes
    return await getDevolucionesEstatusAll({ Referencia: Referencia, Pagina: dataInicial.pagina + 1, Registros: dataInicial.registros, IdCatEstatusDevolucion: estatus }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_PENDIENTES_BUSQUEDA,
            payload: {
                listDevolucionesPendientes: Response.Devoluciones,
                total: Response.Total,
                busqueda: Referencia,
                registros: dataInicial.registros,
                pagina: dataInicial.pagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerEstadoCuentaDevolucionAction = ({ IdDevolucionSolicitud }) => async (dispatch, getSate) => {
    return await getEstadoCuentaDevolucionDowload({ IdDevolucionSolicitud }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_ESTADO_CUENTA_DOWLOAD,
            payload: {
                exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const validarDevolucionAction = ({ IdDevolucionSolicitud }) => async (dispatch) => {
    return await putValidateDevolucion({ IdDevolucionSolicitud }).then(Response => {
        dispatch({
            type: PUT_DEVOLUCIONES_PENDIENTES_APROVAR,
            payload: {
                exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const declinarDevolucionAction = ({ IdDevolucionSolicitud }) => async (dispatch) => {
    return await putDeclinarSolitudRembolsoAgente({ IdDevolucionSolicitud }).then(Response => {
        dispatch({
            type: PUT_DEVOLUCIONES_PENDIENTES_DECLINAR,
            payload: {
                exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
